<template>
  <div class="wrap">
    <div class="my_page">
      <div class="key_visual addImg mypage">
        <div class="container"></div>
      </div>

      <div class="my_page_content custom">
        <div class="container">
          <div class="mypage_tab">
            <ul>
              <li @click="moveToUrl('/mypage')">프로필</li>
              <li class="on">구매내역</li>
            </ul>
          </div>
          <div class="form_area">
            <div class="order_list">
              <div class="list_header">
                <div class="title">구매 내역</div>
                <div class="contact">
                  <div class="txt" @click="moveToUrl('/inquiry')">문의하기</div>
                  <div class="icon">
                    <img
                      src="../../public/assets/images/icon/order_list_arrow_right.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div class="list_body">
                <!-- {{ contentsLength }} -->
                <!-- {{ orderLists.content }} -->
                <div v-if="contentsLength !== 0" class="iflistin">
                  <div
                    v-for="(list, index) in orderLists.content"
                    :key="index"
                    class="list"
                  >
                    <div class="img img_area">
                      <!-- list.order_status로 조절 -->
                      <div
                        v-if="list.order_status === '정상'"
                        class="order_status"
                      >
                        주문 완료
                      </div>
                      <div
                        v-else-if="list.order_status === '취소'"
                        class="order_status"
                      >
                        취소 완료
                      </div>
                      <!-- <div v-else class="order_status"> -->
                      <div
                        v-else-if="list.order_status === '취소요청'"
                        class="order_status"
                      >
                        취소 요청 중
                      </div>
                      <!-- <div v-html="list.order_status"></div> -->
                      <img :src="list.contents_thumbnail" />
                    </div>
                    <div class="info">
                      <div class="nl">
                        <div class="dt">
                          주문일:
                          <span
                            v-html="formattedOrderedDate(list.payment_date)"
                          ></span>
                        </div>
                        <div class="od_num">
                          주문번호: <span v-html="list.order_no"></span>
                        </div>
                      </div>
                      <div class="nl">
                        <div class="title" v-html="list.contents_title"></div>
                        <a
                          v-if="list.delivery.invoice_no"
                          class="check"
                          target="_blank"
                          @click="
                            deliveryInquiry(
                              list.delivery.invoice_courier,
                              list.delivery.invoice_no
                            )
                          "
                        >
                          <div class="check">배송 조회</div>
                        </a>
                        <!-- 구독권만 구매해서 배송조회기능이 쓸모 없는 경우 -->
                        <!-- <div
                          v-else-if="
                            list.options?.length === 1 &&
                            list.options[0]?.name?.includes('구독권')
                          "
                          class=""
                        ></div> -->
                        <a
                          v-else
                          class="check nonInvoiceNo"
                          @click="noninvoiceNum"
                        >
                          <div class="check nonInvoiceNo">배송 조회</div>
                        </a>
                      </div>
                      <div class="nl">
                        <div class="price">
                          <span
                            v-html="Number(list.total_amt).toLocaleString()"
                          ></span
                          >원
                        </div>
                        <!-- {{list.order_status}} -->
                        <div
                          v-if="list.order_status === '정상'"
                          class="check"
                          @click="refundFunc(list)"
                        >
                          취소 및 환불
                        </div>
                        <div
                          v-else-if="list.order_status === '취소'"
                          class="check nonInvoiceNo"
                          @click="showRefundInfo"
                        >
                          취소 완료
                        </div>
                        <div
                          v-else-if="list.order_status === '취소요청'"
                          class="check"
                          @click="waitRefundStatus"
                        >
                          요청 완료
                        </div>
                        <!-- <div v-else class="check" @click="waitRefundStatus">
                          요청 완료
                        </div> -->
                      </div>
                      <div
                        v-for="(option, optionIndex) in list.options"
                        :key="optionIndex"
                      >
                        <div class="nl">
                          <!-- <div class="nl top_space"> -->
                          <div class="opt">
                            <div class="txt">
                              <span v-if="option.name.includes('구독권')"
                                >콘텐츠</span
                              >
                              <span v-else>추가 옵션</span>
                              <!-- 옵션 <span v-html="optionIndex + 1"></span> -->
                            </div>
                            <div
                              v-if="option.name.includes('구독권')"
                              class="val"
                              v-html="option.name"
                            ></div>
                            <div
                              v-else
                              class="val"
                              v-html="option.name + ' - ' + option.count + '개'"
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div class="nl">
                        <div class="detail" @click="toggleOrderInfo(list)">
                          <div class="txt">주문 상세</div>
                          <div class="icon">
                            <img
                              src="../../public/assets/images/icon/page-arrow-right.png"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
                <div v-else class="list empty_buylist">
                  구매 내역이 없습니다.<br />
                  <span>라온 메타데미에서 다양한 콘텐츠를 이용해 보세요.</span>
                </div>
              </div>

              <div class="bbs_paging">
                <div class="container">
                  <ul>
                    <li @click="moveToPrevPageGroup">
                      <a>
                        <img
                          src="../../public/assets/images/icon/page-arrow-left.png"
                          alt=""
                      /></a>
                    </li>
                    <li v-for="pageData in getVisiblePages" :key="pageData">
                      <a
                        class="num"
                        :class="{ on: pageData == pageArray.request_page }"
                        @click="getData(pageData)"
                      >
                        {{ pageData }}
                      </a>
                    </li>
                    <li @click="moveToNextPageGroup">
                      <a>
                        <img
                          src="../../public/assets/images/icon/page-arrow-right.png"
                          alt=""
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showRefundPopup">
    <OrderRefundPopup
      :is-open="showRefundPopup"
      :selected-no="orderNo"
      :order-data="cancelOrderData"
      @update:is-open="toggleRefundPopup"
      @refund-success="handleRefundSuccess"
      @show-success-alert="showSuccessAlert"
    />
  </div>
  <div class="Modals">
    <ModalAlertContents
      :alert-msg="errMsg"
      :is-open="errStatus"
      :is-cost="errCost"
      :is-done="doneCheck"
      :trigger="errTrigger"
      @update:is-open="updateStatus"
    />
  </div>

  <DeliveryCheck v-if="showDeliveryCheck" @close="toggleDeliveryCheck" />
  <div v-if="showOrderInfo" class="orderinfo_bg">
    <div class="orderinfo_popup">
      <OrderInfo
        :is-open="showOrderInfo"
        :selected-no="orderNo"
        @update:is-open="updateShowStatus"
        @close="updateShowStatus"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'

import Cookies from 'vue-cookies'
import DeliveryCheck from '../components/DeliveryCheck.vue'
import OrderInfo from '../components/OrderInfo.vue'
import OrderRefundPopup from '../components/OrderRefundPopup.vue'

import { loadOrderDatas } from '../api/orders'
import ModalAlertContents from '../components/ModalAlertContents.vue'

export default {
  name: 'OrderList',
  components: {
    DeliveryCheck,
    OrderInfo,
    OrderRefundPopup,
    ModalAlertContents,
  },
  setup() {
    /*
    function openNewWindow() {
  const url = 'https://example.com'; // 새 창에서 열고자 하는 URL
  const windowName = '_blank'; // 새 창을 의미하는 이름
  const windowFeatures = 'width=800,height=600'; // 창 크기 등 옵션

  window.open(url, windowName, windowFeatures);
}

    */
    const router = useRouter()

    const errMsg = ref('')
    const errStatus = ref(false)
    const errCost = ref(false)
    const doneCheck = ref(false)
    const errTrigger = ref('')

    const cancelOrderData = ref('')

    const showDeliveryCheck = ref(false)
    const showOrderInfo = ref(false)

    const currentPage = ref('')
    const totalPages = ref('')
    const pageArray = ref([])
    const page = ref(0)
    const pageGroupStart = ref(0)
    const pageGroupEnd = ref(10) // 페이지 그룹의 끝 (10까지 보여줌)

    const orderLists = ref([])
    const contentsLength = ref(0)
    const orderNo = ref('')
    const getAT = ref('')

    const toggleDeliveryCheck = () => {
      showDeliveryCheck.value = !showDeliveryCheck.value
    }

    const toggleOrderInfo = (list) => {
      showOrderInfo.value = true
      orderNo.value = list.order_no
    }
    const updateShowStatus = () => {
      showOrderInfo.value = false
    }

    const moveToUrl = (url) => {
      router.push({ path: url })
    }
    const moveToLogen = (url) => {
      router.push({ path: url })
    }

    const getData = async (getpage) => {
      getAT.value = Cookies.get('access_token')
      if (getAT.value !== null) {
        try {
          const response = await loadOrderDatas(getpage)
          // console.log(response.content.length)
          if (response.status_code === 200) {
            orderLists.value = response
            contentsLength.value = response.content.length
            pageArray.value = response.page_info
            totalPages.value = response.page_info.total_pages
            currentPage.value = response.page_info.request_page
            console.log('orderLists', orderLists.value)
            // console.log(response.content.delivery)
          }
        } catch (error) {
          console.error('데이터로드 실패:', error)
        }
      } else {
        errMsg.value = '비정상적인 접근입니다..'
        errStatus.value = true
        errCost.value = false
        errTrigger.value = 'orderTrigger'
      }
    }

    const handleRefundSuccess = () => {
      // 현재 페이지 데이터를 다시 불러옵니다
      getData(currentPage.value)
    }

    // 페이지 목록 계산
    const getVisiblePages = computed(() => {
      // 마지막 페이지 그룹이 10개 미만일 때 페이지 그룹 범위 조정
      const end = Math.min(pageGroupEnd.value, totalPages.value)
      return Array.from(
        { length: end - pageGroupStart.value },
        (_, i) => pageGroupStart.value + i + 1
      )
    })
    // 페이지 그룹 이동 함수
    const moveToNextPageGroup = () => {
      if (pageGroupEnd.value < totalPages.value) {
        pageGroupStart.value += 10
        pageGroupEnd.value += 10
      }
    }
    const moveToPrevPageGroup = () => {
      if (pageGroupStart.value > 0) {
        pageGroupStart.value -= 10
        pageGroupEnd.value -= 10
      }
    }
    const formattedOrderedDate = (date) => {
      const year = date.slice(0, 4)
      const month = date.slice(4, 6)
      const day = date.slice(6, 8)
      const hour = date.slice(8, 10)
      const minute = date.slice(10, 12)
      const second = date.slice(12, 14)
      return `${year} .${month} .${day} ${hour}:${minute}:${second}`
    }
    const showRefundPopup = ref(false)
    const refundFunc = (list) => {
      console.log(list)
      orderNo.value = list.order_no // 선택된 주문번호 설정
      showRefundPopup.value = true // 팝업 열기
      cancelOrderData.value = {
        thumbnail: list.contents_thumbnail,
        orderDate: formattedOrderedDate(list.payment_date),
        orderNo: list.order_no,
        title: list.contents_title,
        amount: Number(list.total_amt).toLocaleString(),
      }
    }
    const toggleRefundPopup = () => {
      showRefundPopup.value = false // 팝업 닫기
    }
    const showRefundInfo = () => {
      // 취소 완료된 건에 대한 정보를 띄워줘야함.
      errMsg.value =
        '취소 또는 환불이 완료된 주문입니다. <br> 문의사항은 서비스 이용 문의를 통하여 남겨주세요.'
      errStatus.value = true
      errCost.value = true // 이거 없으면 ModalAlertContents에서 content로 넘겨줌
      doneCheck.value = true
    }
    const waitRefundStatus = () => {
      // 취소 완료된 건에 대한 정보를 띄워줘야함.
      errMsg.value = '취소 또는 환불 요청이 완료된 주문입니다.' // 뒤쪽에 어떻게 처리 후에 취소 완료 띄워줄건지 멘트 정해야함.
      errStatus.value = true
      errCost.value = true // 이거 없으면 ModalAlertContents에서 content로 넘겨줌
    }
    const noninvoiceNum = () => {
      errMsg.value =
        '운송장을 확인할 수 없습니다. <br> 운송장이 등록되지 않았거나 상품 준비 중입니다.'
      errStatus.value = true
      errCost.value = true // 이거 없으면 ModalAlertContents에서 content로 넘겨줌
    }
    const updateStatus = () => {
      errStatus.value = false
    }
    const deliveryInquiry = (delivComp, delivNum) => {
      const url = ref('')
      const windowName = '_blank' // 새 창을 의미하는 이름

      switch (true) {
        case delivComp.includes('우체국'):
          url.value = `https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${delivNum}`
          break
        case delivComp.includes('로젠'):
          url.value = `https://www.ilogen.com/web/personal/trace/${delivNum}`
          break
        case delivComp.includes('CJ'):
          url.value = `https://www.cjlogistics.com/ko/tool/parcel/tracking?gnbInvcNo=${delivNum}`
          break
        case delivComp.includes('한진'):
          url.value = `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=${delivNum}`
          break
        case delivComp.includes('롯데'):
          url.value = `https://www.lotteglogis.com/home/reservation/tracking/linkView?InvNo=${delivNum}`
          break
        case delivComp.includes('자체'):
          errMsg.value =
            '판매자가 직접 발송하는 상품입니다. <br> 서비스 이용 문의를 통해 문의 해주시길 바랍니다.'
          errStatus.value = true
          errCost.value = false
          errTrigger.value = 'nonInvoiceCourier' // nonInvoiceCourier
          break
        default:
          return
      }

      // url이 존재할 경우 새 창으로 열기
      if (url.value) {
        window.open(url.value, windowName)
      }
    }
    const showSuccessAlert = () => {
      errMsg.value = '취소 및 환불 요청이 접수되었습니다.'
      errStatus.value = true
      errCost.value = true
    }
    onMounted(() => {
      getData()
    })

    return {
      errMsg,
      errStatus,
      errCost,
      doneCheck,
      errTrigger,
      updateStatus,

      getData,

      moveToUrl,
      moveToLogen,
      showDeliveryCheck,
      toggleDeliveryCheck,
      showOrderInfo,
      toggleOrderInfo,
      updateShowStatus,

      formattedOrderedDate,

      orderLists,
      contentsLength,
      pageArray,
      page,
      totalPages,
      currentPage,

      pageGroupStart,
      pageGroupEnd,
      moveToNextPageGroup,
      moveToPrevPageGroup,
      orderNo,
      refundFunc,
      toggleRefundPopup,

      showRefundInfo,
      waitRefundStatus,
      noninvoiceNum,

      getVisiblePages,
      deliveryInquiry,

      showRefundPopup,
      handleRefundSuccess,
      showSuccessAlert,

      cancelOrderData,
    }
  },
}
</script>

<style></style>
